import { createApp } from 'vue'
import App from './App.vue'
import router from './router';

import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import './style.css'
import VueApexCharts from 'vue3-apexcharts';

const vuetify = createVuetify({
  components,
  directives,
  theme: {
    defaultTheme: 'light'
  },
})

createApp(App).use(vuetify).use(router).component('apexchart', VueApexCharts).mount('#app')

// Register Service Worker for PWA + Share Target support
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/sw.js').then((reg) => {
    console.log('[PWA] Service Worker registered:', reg.scope);
  }).catch((err) => {
    console.warn('[PWA] Service Worker registration failed:', err);
  });
}